import { gsap } from 'gsap'

export function setupPageTransition(swup, callbacks = {}) {
  const curtain = document.querySelector('.page-transition')
  if (!curtain) return
  const picto = curtain.querySelector('.page-transition--picto')

  // Si le menu hamburger est ouvert au clic, on le ferme avant transition
  swup.hooks.on('link:click', () => {
    const hamburger = document.querySelector('.hamburger.is-active')
    if (hamburger) hamburger.click()
  })

  // Rideau monte du bas
  swup.hooks.replace('animation:out:await', () => {
    callbacks.onBeforeLeave?.()

    return new Promise(resolve => {
      gsap.set(curtain, { y: '100%' })
      if (picto) gsap.set(picto, { opacity: 0 })

      const tl = gsap.timeline({ onComplete: resolve })
      tl.to(curtain, {
        y: '0%',
        duration: 0.7,
        ease: 'power3.inOut'
      })
      if (picto) {
        tl.to(picto, {
          opacity: 1,
          duration: 0.25
        }, '-=0.25')
      }
    })
  })

  // Contenu remplacé : reset scroll + re-init blocs
  swup.hooks.on('content:replace', () => {
    if (window.lenis) {
      window.lenis.destroy()
      window.lenis = null
    }
    // Force scroll to top via tous les chemins possibles (Lenis détruit, scroll natif actif)
    window.scrollTo(0, 0)
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
    callbacks.onContentReplaced?.()
  })

  // Rideau sort par le haut
  swup.hooks.replace('animation:in:await', () => {
    return new Promise(resolve => {
      const tl = gsap.timeline({
        onComplete: () => {
          gsap.set(curtain, { y: '100%' })
          if (picto) gsap.set(picto, { opacity: 0 })
          resolve()
        }
      })

      if (picto) {
        tl.to(picto, { opacity: 0, duration: 0.2 })
      }
      tl.to(curtain, {
        y: '-100%',
        duration: 0.7,
        ease: 'power3.inOut'
      }, '-=0.1')
    })
  })
}
